import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@aimsos/auth';
import WorkspacesPage from './WorkspacesPage.jsx';

/** Workspaces domain routes (CT-4209), mounted at /admin-studio/workspaces. */
const WorkspacesRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <ProtectedRoute>
          <WorkspacesPage />
        </ProtectedRoute>
      }
    />
    <Route path="*" element={<Navigate to="" replace />} />
  </Routes>
);

export default WorkspacesRoutes;
